export default "__VITE_ASSET__4e8b6ddb__"